import React from 'react';
import { StudioBaseImageV2 } from 'shared/studio/StudioBaseImage/StudioBaseImage';
import IconClose from 'shared/ui/Icon/24/IconClose';
import { ResponsiveImageNoValidation } from 'types/studio/studio';
import styles from './ImageModal.module.scss';

export type ModalProps = {
  onClose: () => void;
};

type ImageProps = {
  modalImage?: ResponsiveImageNoValidation;
} & Pick<ModalProps, 'onClose'>;

const ImageModal = ({ modalImage, onClose }: ImageProps) => (
  <div className={styles.modalInner}>
    <div className={styles.modalControls}>
      <button type="button" className={styles.modalButtonClose} onClick={onClose}>
        <IconClose className={styles.iconClose} />
      </button>
    </div>
    <div className={styles.imageContainer}>
      {modalImage && modalImage.image && (
        <StudioBaseImageV2
          image={modalImage.image}
          tabletImage={modalImage.tabletImage}
          mobileImage={modalImage.mobileImage}
          className={styles.modalImageWrap}
          childClassName={styles.modalImage}
        />
      )}
    </div>
  </div>
);

export default ImageModal;
